import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useRoomLoadingState } from "./useRoomLoadingState";
import { LoadingScreenFluent } from "./LoadingScreenFluent";
import { remountUI } from "../../hub";
import { ExitReason } from "./ExitedRoomScreen";
import { useRoomAssetLoading } from "./RoomAssetLoadingTracker";

export function LoadingScreenContainer({ onLoaded, scene, hub, backgroundColor = null, destination = null }) {
  const {
    loading,
    message,
    environmentLoaded,
    donePreloading,
    allObjectsLoaded,
    externalAssetLoading,
    externalAssetLoaded,
    externalAssetError
  } = useRoomLoadingState(scene);
  const { objectCount: trackedObjectCount, loadedCount: trackedLoadedCount } = useRoomAssetLoading();

  // Handle external asset error by showing error screen
  useEffect(() => {
    if (externalAssetError) {
      console.error("External asset failed to load, showing error screen");
      remountUI({ roomUnavailableReason: ExitReason.sceneError });
    }
  }, [externalAssetError]);

  useEffect(() => {
    if (!loading) {
      onLoaded();
    }
  }, [loading, onLoaded]);

  // Override message when loading external asset
  const isLoadingExternal = externalAssetLoading && !externalAssetLoaded;
  const displayMessage = isLoadingExternal ? "Loading asset..." : message;

  const adjustedObjectCount = externalAssetLoading ? trackedObjectCount + 1 : trackedObjectCount;
  const adjustedLoadedCount = externalAssetLoaded ? trackedLoadedCount + 1 : trackedLoadedCount;

  return (
    <LoadingScreenFluent
      backgroundColor={backgroundColor}
      message={displayMessage}
      objectCount={adjustedObjectCount}
      loadedCount={adjustedLoadedCount}
      environmentLoaded={environmentLoaded}
      donePreloading={donePreloading}
      allObjectsLoaded={allObjectsLoaded}
      destination={destination}
      hub={hub}
    />
  );
}

LoadingScreenContainer.propTypes = {
  scene: PropTypes.object.isRequired,
  hub: PropTypes.object,
  onLoaded: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  destination: PropTypes.string
};
